import React from 'react';

export function resolveRouteProps(props) {
  if (props == null) return {};
  return typeof props === 'function' ? props() : props;
}

export function wrapWithProviders(providers, children) {
  if (!providers?.length) return children;
  return providers.reduceRight(
    (acc, Provider) => React.createElement(Provider, null, acc),
    children
  );
}
